import { render, staticRenderFns } from "./OrderReportSummary.vue?vue&type=template&id=b0a8646a&scoped=true"
import script from "./OrderReportSummary.vue?vue&type=script&lang=js"
export * from "./OrderReportSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderReportSummary.vue?vue&type=style&index=0&id=b0a8646a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a8646a",
  null
  
)

export default component.exports